import { EDatasourceType, type IActionDefinitionDto } from "@kuika/kuika-cl-model";

export function isOfflineCompatibleActionDefinition(definition: IActionDefinitionDto): boolean {
  if (definition.requiresConnection === true) {
    return false;
  }

  return (
    definition.actionType === EDatasourceType.SystemJSFunctions ||
    definition.actionType === EDatasourceType.JavaScriptAction
  );
}
